
const scrollToElement = () => {
    // if (muster == undefined) {
    //     document.querySelector('#button_wrapper').scrollIntoView();
    // }
    document.querySelector('#button_wrapper').scrollIntoView();

   //document.querySelector('#inner_masseMenge_wrapper').nextSibling.scrollIntoView();

}

export default scrollToElement;